import { z } from 'zod';
import { vaultPostRequest } from '../helpers';

const responseSchema = z.object({ accepted: z.boolean(), reset: z.number() });

export type IRegenImgFailedResponse = z.infer<typeof responseSchema>;

export async function regenImgFailedApi(): Promise<IRegenImgFailedResponse> {
  return vaultPostRequest({ path: '/img/regen-failed', body: {}, schema: responseSchema });
}
